import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PaymentCollectorService } from '@core/services/entities/payment-collector.service';
import { PaymentCollectorResponseDto } from '@domain/payment-collector/dtos/payment-collector.response.dto';
import { PaymentCollectorRepository } from '@domain/payment-collector/repositories/payment-collector.repository';
import { Observable } from 'rxjs';
import { GetPaymentCollectorRequestDto } from '@domain/payment-collector/dtos/get-payment-collector.request.dto';
import { UpdateStatePaymentCollectorRequestDto } from '@domain/payment-collector/dtos/update-state-payment-collector.request.dto';
import { UpdatePaymentCollectorRequestDto } from '@domain/payment-collector/dtos/update-payment-collector.request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class PaymentCollectorRepositoryService
  implements PaymentCollectorRepository
{
  constructor(private paymentCollectorService: PaymentCollectorService) {}

  get(
    request: GetPaymentCollectorRequestDto,
  ): Observable<ApiResponse<PaymentCollectorResponseDto[]>> {
    return this.paymentCollectorService.get(request);
  }

  show(request: RefId): Observable<ApiResponse<PaymentCollectorResponseDto>> {
    return this.paymentCollectorService.show(request);
  }

  update(
    request: UpdatePaymentCollectorRequestDto,
  ): Observable<ApiResponse<PaymentCollectorResponseDto>> {
    return this.paymentCollectorService.update(request);
  }

  updateState(
    request: UpdateStatePaymentCollectorRequestDto,
  ): Observable<ApiResponse<PaymentCollectorResponseDto>> {
    return this.paymentCollectorService.updateState(request);
  }
}
